export enum AkaHouseContentsInsuranceType {
  AKA_HOUSE_CONTENTS_STANDARD = "akaHouseContentsStandard",
}
